import {Vozilo} from "@/services/BackendProxies";
import {Action, Mutation, State} from "vuex-class";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

export class TabBase extends mixins(ComponentBaseMixin) {
    @Mutation setVozilo;
    @State vozilo: Vozilo;
    @Action sacuvajVozilo;

    createNew() {
        if (!this.$route.params.id) {
            this.setVozilo(new Vozilo());
        } else {
            this.$router.push('/podaci-vozila');
        }
    }

    async save() {
        const id = await this.saveData(() => this.sacuvajVozilo(this.vozilo))();
        this.$router.replace(`/podaci-vozila/${id}`);
    }
}
